import { useNavigate } from 'react-router-dom';
import { IRowData } from '../../../../base';
import { RoutePaths } from '../../../../routes/RoutePaths';

export const useTableCallbacks = () => {
    const navigate = useNavigate();

    const onRowClick = (item: IRowData) => {
        navigate(`${RoutePaths.jobs}/${item?.data?.id}/`);
    };

    return { onRowClick };
};
